import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { initEvents } from "../../data-store/actions/events-actions";
import { Link } from "react-router-dom";
import {
  Button,
  Typography,
  Container,
  Grid,
  Paper,
} from "@material-ui/core";
import AuthorizedUsersList from "./AuthorizedUsers/AuthorizedUsersList";
import LoginInitView from "../Login/LoginInitView";
import DashportChat from "./DashportChat";

const Home = () => {
  const dispatch = useDispatch();
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const events = useSelector((state) => state.events.events);

  useEffect(() => {
    dispatch(initEvents());
  }, [dispatch]);

  const eventosOrdenados = events
    ? Object.values(events)
      .filter((e) => e.fechaEvento)
      .sort((a, b) => new Date(a.fechaEvento) - new Date(b.fechaEvento))
    : [];

  const fechaActual = new Date();

  const eventosPasados = eventosOrdenados
    .filter((e) => new Date(e.fechaEvento) < fechaActual)
    .slice(-2); // Últimos 2

  const eventosProximos = eventosOrdenados
    .filter((e) => new Date(e.fechaEvento) >= fechaActual)
    .slice(0, 2); // Próximos 2

  const eventosCercanos = [...eventosPasados, ...eventosProximos];

  return (
    <Container className="container-home">

      {!atleteAccount ? (
        <LoginInitView />
      ) : (
        <div style={{ marginTop: 40 }}>
          <AuthorizedUsersList />
        </div>
      )}
    </Container>
  );
};

export default Home;
